import { useNavigate, useSearch } from "@tanstack/react-router";
import { Suspense } from "react";
import {
	Tabs,
	TabsIndicator,
	TabsList,
	TabsPanel,
	TabsTab,
} from "@/components/Tabs";
import { Earnings } from "./earnings/Earnings";
import { EarningsSkeleton } from "./earnings/EarningsSkeleton";
import { PaymentMethods } from "./payment-methods/PaymentMethods";
import { PaymentMethodsSkeleton } from "./payment-methods/PaymentMethodsSkeleton";
import { Payouts } from "./payouts/Payouts";
import { PayoutsSkeleton } from "./payouts/PayoutsSkeleton";

const VALID_TABS = ["earnings", "payouts", "payment_methods"] as const;
type TabValue = (typeof VALID_TABS)[number];

export function Finances() {
	const { tab } = useSearch({ from: "/_app/finances/" });
	const navigate = useNavigate();

	// Ensure tab is valid, default to earnings
	const currentTab = VALID_TABS.includes(tab as TabValue) ? tab : "earnings";

	const handleTabChange = (value: string | number | null) => {
		if (typeof value === "string" && VALID_TABS.includes(value as TabValue)) {
			navigate({
				to: "/finances",
				search: (prev) => ({ ...prev, tab: value as TabValue }),
			});
		}
	};

	return (
		<div className="flex flex-col gap-6">
			<Tabs
				value={currentTab}
				onValueChange={handleTabChange}
				className="w-full"
			>
				<TabsList>
					<TabsTab value="earnings">Earnings</TabsTab>
					<TabsTab value="payouts">Payouts</TabsTab>
					<TabsTab value="payment_methods">Payment Methods</TabsTab>
					<TabsIndicator />
				</TabsList>
				<TabsPanel value="earnings">
					<div className="py-4">
						<Suspense fallback={<EarningsSkeleton />}>
							<Earnings />
						</Suspense>
					</div>
				</TabsPanel>
				<TabsPanel value="payouts">
					<div className="py-4">
						<Suspense fallback={<PayoutsSkeleton />}>
							<Payouts />
						</Suspense>
					</div>
				</TabsPanel>
				<TabsPanel value="payment_methods">
					<div className="py-4">
						<Suspense fallback={<PaymentMethodsSkeleton />}>
							<PaymentMethods />
						</Suspense>
					</div>
				</TabsPanel>
			</Tabs>
		</div>
	);
}
